import { get } from 'lodash-es'

export const toWorkflowData = (data: Json): WorkflowData => ({
    moveTo: get(data, '_embedded.workflow.moveTo', ''),
    canAccess: get(data, '_embedded.workflow.canAccess', false),
})
